import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="bg-[#FAF7F2] py-12 md:py-18 px-5 md:px-12" data-id="element-77">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto text-center" data-id="element-78">
        {/* Section Label */}
        <div className="mb-6" data-id="element-79">
          <div className="h-px w-16 bg-[#C9A96E] mx-auto mb-4" data-id="element-80" />
          <span className="text-[#C9A96E] uppercase tracking-[0.2em] text-xs font-medium" data-id="element-81">
            El Gancho
          </span>
        </div>

        {/* Main Copy */}
        <p className="text-xl md:text-2xl lg:text-3xl text-[#1C1C1C] leading-relaxed font-serif mb-6" data-id="element-82">
          ¿Alguna vez has entrado a una tienda de lujo o a un hotel de 5
          estrellas y te has quedado mirando las cortinas?
        </p>

        <p className="text-lg md:text-xl text-[#1C1C1C]/80 leading-relaxed mb-6" data-id="element-83">
          Tienen ese <span className="font-semibold text-[#1C1C1C]" data-id="element-84">peso</span>,
          esa{' '}
          <span className="font-semibold text-[#1C1C1C]" data-id="element-85">
            caída de "mármol"
          </span>{' '}
          y esos{' '}
          <span className="font-semibold text-[#1C1C1C]" data-id="element-86">
            pliegues perfectos
          </span>
          ...
        </p>

        <p className="text-lg md:text-xl text-[#1C1C1C]/70 leading-relaxed mb-8" data-id="element-87">
          Luego miras las de tu casa y parecen{' '}
          <span className="italic" data-id="element-88">simples sábanas colgadas</span>.
        </p>

        {/* The Reveal */}
        <div className="bg-white border border-[#C9A96E]/20 rounded-lg p-6 md:p-8 shadow-sm" data-id="element-89">
          <p className="text-lg md:text-xl text-[#1C1C1C] font-medium mb-2" data-id="element-90">
            No es tu falta de talento.
          </p>
          <p className="text-2xl md:text-3xl font-serif text-[#C9A96E]" data-id="element-91">
            Es que te falta el{' '}
            <span className="italic" data-id="element-92">"Secreto del Peso"</span>.
          </p>
        </div>
      </motion.div>
    </section>;
}